import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { getMinMaxSchemaValue } from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.too_small:
      return {
        message: t('sharedFlows_contentsNxt:steps.contents_living_space.input.error.min', {
          min: issue.minimum,
        }),
      }

    case z.ZodIssueCode.too_big:
      return {
        message: t('sharedFlows_contentsNxt:steps.contents_living_space.input.error.max', {
          max: issue.maximum,
        }),
      }
    default:
      return { message: ctx.defaultError }
  }
}

const contents_living_space = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('living_space_square_meters')]:
        BaseSchema_ContentsV1GetsafeDe.shape.living_space_square_meters,
    }),
    // We add a custom error map based on the validation messages that we need for this step
    // this allows us to overwrite only the errors we need without needing to change the schema
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_living_space.title',
        },
      },
      {
        type: 'input',
        inputType: 'integer',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('living_space_square_meters'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_living_space.input.label',
        },
      },
      {
        type: 'spacer',
        size: 'small',
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_living_space.infoBox.text',
          values: {
            min: {
              type: 'staticValue',
              value: String(
                getMinMaxSchemaValue(
                  BaseSchema_ContentsV1GetsafeDe.shape.living_space_square_meters.innerType(),
                  'min'
                )
              ),
            },
            max: {
              type: 'staticValue',
              value: String(
                getMinMaxSchemaValue(
                  BaseSchema_ContentsV1GetsafeDe.shape.living_space_square_meters.innerType(),
                  'max'
                )
              ),
            },
          },
        },
      },
    ],
    nextStep: 'contents_insured_amount',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default contents_living_space
